export default {
  categoryTree: [
    {
      name: "Satılık",
      url: "satilik",
      child: [
        {
          id: 2,
          name: "Konut",
          url: "satilik-konut",
          tradeTypeId: 2,
          tradeTypeSlug: "satilik",
          categorySlug: "konut",
          child: [
            {
              id: 1,
              name: "Daire",
              url: "satilik-daire",
              tradeTypeSlug: "satilik",
              categorySlug: "konut",
              estateTypeId: 19,
              estateTypeSlug: "daire",
            },
            {
              id: 206,
              name: "Residence",
              url: "satilik-residence",
              tradeTypeSlug: "satilik",
              categorySlug: "konut",
              estateTypeId: 28,
              estateTypeSlug: "residence",
            },
            {
              id: 3,
              name: "Müstakil Ev",
              url: "satilik-mustakil-ev",
              tradeTypeSlug: "satilik",
              categorySlug: "konut",
              estateTypeId: 27,
              estateTypeSlug: "mustakil-ev",
            },
            {
              id: 2,
              name: "Villa",
              url: "satilik-villa",
              tradeTypeSlug: "satilik",
              categorySlug: "konut",
              estateTypeId: 30,
              estateTypeSlug: "villa",
            },
            {
              id: 6,
              name: "Yazlık",
              url: "satilik-yazlik",
              tradeTypeSlug: "satilik",
              categorySlug: "konut",
              estateTypeId: 31,
              estateTypeSlug: "yazlik",
            },
            {
              id: 10,
              name: "Devremülk",
              url: "satilik-devremulk",
              tradeTypeSlug: "satilik",
              categorySlug: "konut",
              estateTypeId: 22,
              estateTypeSlug: "devremulk",
            },
            {
              id: 201,
              name: "Çiftlik Evi",
              url: "satilik-ciftlik-evi",
              tradeTypeSlug: "satilik",
              categorySlug: "konut",
              estateTypeId: 21,
              estateTypeSlug: "ciftlik-evi",
            },
            {
              id: 202,
              name: "Dağ Evi",
              url: "satilik-dag-evi",
              tradeTypeSlug: "satilik",
              categorySlug: "konut",
              estateTypeId: 23,
              estateTypeSlug: "dag-evi",
            },
            {
              id: 205,
              name: "Köy Evi",
              url: "satilik-koy-evi",
              tradeTypeSlug: "satilik",
              categorySlug: "konut",
              estateTypeId: 26,
              estateTypeSlug: "koy-evi",
            },
            {
              id: 204,
              name: "Köşk",
              url: "satilik-kosk",
              tradeTypeSlug: "satilik",
              categorySlug: "konut",
              estateTypeId: 25,
              estateTypeSlug: "kosk",
            },
            {
              id: 4,
              name: "Yalı (Komple)",
              url: "satilik-yali",
              tradeTypeSlug: "satilik",
              categorySlug: "konut",
              estateTypeId: 32,
              estateTypeSlug: "yali",
            },
            {
              id: 207,
              name: "Yalı Dairesi",
              url: "satilik-yali-dairesi",
              tradeTypeSlug: "satilik",
              categorySlug: "konut",
              estateTypeId: 33,
              estateTypeSlug: "yali-dairesi",
            },
            {
              id: 5,
              name: "Bina",
              url: "satilik-bina",
              tradeTypeSlug: "satilik",
              categorySlug: "konut",
              estateTypeId: 20,
              estateTypeSlug: "bina",
            },
            {
              id: 203,
              name: "Kooperatif",
              url: "satilik-kooperatif",
              tradeTypeSlug: "satilik",
              categorySlug: "konut",
              estateTypeId: 24,
              estateTypeSlug: "kooperatif",
            },
            {
              id: 208,
              name: "Prefabrik",
              url: "satilik-prefabrik",
              tradeTypeSlug: "satilik",
              categorySlug: "konut",
              estateTypeId: 29,
              estateTypeSlug: "prefabrik",
            },
          ],
          testSelector: "for-sale-menu-housing-button",
        },
        {
          id: 1,
          name: "Arsa",
          url: "satilik-arsa",
          tradeTypeId: 1,
          tradeTypeSlug: "satilik",
          categorySlug: "arsa",
          child: [
            {
              id: 1,
              name: "Konut İmarlı",
              url: "satilik-konut-imarli-arsa",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 6,
              estateTypeSlug: "konut-imarli-arsa",
            },
            {
              id: 912,
              name: "Bağ & Bahçe",
              url: "satilik-bag-bahce",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 1,
              estateTypeSlug: "bag-bahce",
            },
            {
              id: 12,
              name: "Tarla",
              url: "satilik-tarla",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 13,
              estateTypeSlug: "tarla",
            },
            {
              id: 913,
              name: "Zeytinlik",
              url: "satilik-zeytinlik",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 18,
              estateTypeSlug: "zeytinlik",
            },
            {
              id: 5,
              name: "Çiftlik",
              url: "satilik-ciftlik",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 2,
              estateTypeSlug: "ciftlik",
            },
            {
              id: 2,
              name: "Konut/Ticaret Alanı",
              url: "satilik-ticaret-alani",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 5,
              estateTypeSlug: "ticaret-alani",
            },
            {
              id: 3,
              name: "Toplu Konut İçin",
              url: "satilik-toplu-konut",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 15,
              estateTypeSlug: "toplu-konut",
            },
            {
              id: 914,
              name: "Villa İmarlı",
              url: "satilik-villa-imarli-arsa",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 17,
              estateTypeSlug: "villa-imarli-arsa",
            },
            {
              id: 7,
              name: "Ticari İmarlı",
              url: "satilik-ticari-imarli-arsa",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 14,
              estateTypeSlug: "ticari-imarli-arsa",
            },
            {
              id: 9,
              name: "Turizm İmarlı",
              url: "satilik-turizm-imarli-arsa",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 16,
              estateTypeSlug: "turizm-imarli-arsa",
            },
            {
              id: 8,
              name: "Sanayi İmarlı",
              url: "satilik-sanayi-imarli-arsa",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 11,
              estateTypeSlug: "sanayi-imarli-arsa",
            },
            {
              id: 11,
              name: "Depo/Antrepo İzinli",
              url: "satilik-depo-antrepo-izinli",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 3,
              estateTypeSlug: "depo-antrepo-izinli",
            },
            {
              id: 13,
              name: "Hastane (Sağlık Tesisi)",
              url: "satilik-arsa-hastane",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 4,
              estateTypeSlug: "arsa-hastane",
            },
            {
              id: 14,
              name: "Okul (Eğitim Tesisi)",
              url: "satilik-okul-arsasi",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 9,
              estateTypeSlug: "okul-arsasi",
            },
            {
              id: 10,
              name: "Maden Ocağı",
              url: "satilik-maden-ocagi",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 7,
              estateTypeSlug: "maden-ocagi",
            },
            {
              id: 6,
              name: "Muhtelif Arsa",
              url: "satilik-muhtelif-arsa",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 8,
              estateTypeSlug: "muhtelif-arsa",
            },
            {
              id: 4,
              name: "Özel Kullanım",
              url: "satilik-ozel-arsa",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 10,
              estateTypeSlug: "ozel-arsa",
            },
            {
              id: 15,
              name: "Sit Alanı",
              url: "satilik-sit-alani",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 12,
              estateTypeSlug: "sit-alani",
            },
            {
              id: 915,
              name: "Turizm/Konut Alanı",
              url: "satilik-turizm-konut-alani",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 63,
              estateTypeSlug: "turizm-konut-alani",
            },
            {
              id: 916,
              name: "Ada",
              url: "satilik-ada",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 64,
              estateTypeSlug: "ada",
            },
            {
              id: 917,
              name: "Arazi",
              url: "satilik-arazi",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 65,
              estateTypeSlug: "arazi",
            },
          ],
          testSelector: "for-sale-menu-land-button",
        },
        {
          id: 1,
          name: "Kat Karşılığı Arsa",
          url: "kat-karsiligi-arsa",
          tradeTypeId: 9,
          tradeTypeSlug: "kat-karsiligi",
          categorySlug: "arsa",
          child: [
            {
              id: 1,
              name: "Konut İmarlı",
              url: "kat-karsiligi-konut-imarli-arsa",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 6,
              estateTypeSlug: "konut-imarli-arsa",
            },
            {
              id: 912,
              name: "Bağ & Bahçe",
              url: "kat-karsiligi-bag-bahce",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 1,
              estateTypeSlug: "bag-bahce",
            },
            {
              id: 12,
              name: "Tarla",
              url: "kat-karsiligi-tarla",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 13,
              estateTypeSlug: "tarla",
            },
            {
              id: 913,
              name: "Zeytinlik",
              url: "kat-karsiligi-zeytinlik",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 18,
              estateTypeSlug: "zeytinlik",
            },
            {
              id: 5,
              name: "Çiftlik",
              url: "kat-karsiligi-ciftlik",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 2,
              estateTypeSlug: "ciftlik",
            },
            {
              id: 2,
              name: "Konut/Ticaret Alanı",
              url: "kat-karsiligi-ticaret-alani",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 5,
              estateTypeSlug: "ticaret-alani",
            },
            {
              id: 3,
              name: "Toplu Konut İçin",
              url: "kat-karsiligi-toplu-konut",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 15,
              estateTypeSlug: "toplu-konut",
            },
            {
              id: 914,
              name: "Villa İmarlı",
              url: "kat-karsiligi-villa-imarli-arsa",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 17,
              estateTypeSlug: "villa-imarli-arsa",
            },
            {
              id: 7,
              name: "Ticari İmarlı",
              url: "kat-karsiligi-ticari-imarli-arsa",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 14,
              estateTypeSlug: "ticari-imarli-arsa",
            },
            {
              id: 9,
              name: "Turizm İmarlı",
              url: "kat-karsiligi-turizm-imarli-arsa",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 16,
              estateTypeSlug: "turizm-imarli-arsa",
            },
            {
              id: 8,
              name: "Sanayi İmarlı",
              url: "kat-karsiligi-sanayi-imarli-arsa",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 11,
              estateTypeSlug: "sanayi-imarli-arsa",
            },
            {
              id: 11,
              name: "Depo/Antrepo İzinli",
              url: "kat-karsiligi-depo-antrepo-izinli",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 3,
              estateTypeSlug: "depo-antrepo-izinli",
            },
            {
              id: 13,
              name: "Hastane (Sağlık Tesisi)",
              url: "kat-karsiligi-arsa-hastane",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 4,
              estateTypeSlug: "arsa-hastane",
            },
            {
              id: 14,
              name: "Okul (Eğitim Tesisi)",
              url: "kat-karsiligi-okul-arsasi",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 9,
              estateTypeSlug: "okul-arsasi",
            },
            {
              id: 10,
              name: "Maden Ocağı",
              url: "kat-karsiligi-maden-ocagi",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 7,
              estateTypeSlug: "maden-ocagi",
            },
            {
              id: 6,
              name: "Muhtelif Arsa",
              url: "kat-karsiligi-muhtelif-arsa",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 8,
              estateTypeSlug: "muhtelif-arsa",
            },
            {
              id: 4,
              name: "Özel Kullanım",
              url: "kat-karsiligi-ozel-arsa",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 10,
              estateTypeSlug: "ozel-arsa",
            },
            {
              id: 15,
              name: "Sit Alanı",
              url: "kat-karsiligi-sit-alani",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 12,
              estateTypeSlug: "sit-alani",
            },
            {
              id: 915,
              name: "Turizm/Konut Alanı",
              url: "kat-karsiligi-turizm-konut-alani",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 63,
              estateTypeSlug: "turizm-konut-alani",
            },
            {
              id: 916,
              name: "Ada",
              url: "kat-karsiligi-ada",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 64,
              estateTypeSlug: "ada",
            },
            {
              id: 917,
              name: "Arazi",
              url: "kat-karsiligi-arazi",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 65,
              estateTypeSlug: "arazi",
            },
          ],
          testSelector: "for-sale-menu-land-exchange-for-floor-button",
        },
        {
          id: 3,
          name: "İşyeri",
          url: "satilik-isyeri",
          tradeTypeId: 3,
          tradeTypeSlug: "satilik",
          categorySlug: "isyeri",
          child: [
            {
              id: 307,
              name: "Dükkan & Mağaza",
              url: "satilik-magaza",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 41,
              estateTypeSlug: "magaza",
            },
            {
              id: 8,
              name: "Büro",
              url: "satilik-buro",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 39,
              estateTypeSlug: "buro",
            },
            {
              id: 3,
              name: "Müstakil İşyeri",
              url: "satilik-mustakil-isyeri",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 48,
              estateTypeSlug: "mustakil-isyeri",
            },
            {
              id: 9,
              name: "Ofis",
              url: "satilik-ofis",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 49,
              estateTypeSlug: "ofis",
            },
            {
              id: 1,
              name: "Apartman Dairesi",
              url: "satilik-apartman-dairesi",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 34,
              estateTypeSlug: "apartman-dairesi",
            },
            {
              id: 5,
              name: "Bina",
              url: "satilik-bina-isyeri",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 36,
              estateTypeSlug: "bina-isyeri",
            },
            {
              id: 2,
              name: "Villa (İşyeri)",
              url: "satilik-isyeri-villa",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 53,
              estateTypeSlug: "isyeri-villa",
            },
            {
              id: 308,
              name: "Plaza (Komple)",
              url: "satilik-plaza",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 50,
              estateTypeSlug: "plaza",
            },
            {
              id: 309,
              name: "Plaza Katı",
              url: "satilik-plaza-kati",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 51,
              estateTypeSlug: "plaza-kati",
            },
            {
              id: 301,
              name: "Atölye",
              url: "satilik-atolye",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 35,
              estateTypeSlug: "atolye",
            },
            {
              id: 18,
              name: "Benzin İstasyonu",
              url: "satilik-benzin-istasyonu",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 37,
              estateTypeSlug: "benzin-istasyonu",
            },
            {
              id: 302,
              name: "Depo",
              url: "satilik-depo",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 40,
              estateTypeSlug: "depo",
            },
            {
              id: 11,
              name: "Fabrika",
              url: "satilik-fabrika",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 42,
              estateTypeSlug: "fabrika",
            },
            {
              id: 304,
              name: "Hastane",
              url: "satilik-hastane",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 44,
              estateTypeSlug: "hastane",
            },
            {
              id: 305,
              name: "İşhanı (Komple)",
              url: "satilik-ishani",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 45,
              estateTypeSlug: "ishani",
            },
            {
              id: 306,
              name: "İşhanı Katı",
              url: "satilik-ishani-kati",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 46,
              estateTypeSlug: "ishani-kati",
            },
            {
              id: 330,
              name: "Kafe & Bar",
              url: "satilik-bar",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 47,
              estateTypeSlug: "bar",
            },
            {
              id: 332,
              name: "Restaurant",
              url: "satilik-restaurant",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 52,
              estateTypeSlug: "restaurant",
            },
            {
              id: 303,
              name: "Genel",
              url: "satilik-genel-isyeri",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 43,
              estateTypeSlug: "genel-isyeri",
            },
            {
              id: 701,
              name: "Büfe",
              url: "satilik-bufe",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 38,
              estateTypeSlug: "bufe",
            },
            {
              id: 401,
              name: "Çiftlik",
              url: "satilik-ciftlik-isyeri",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 62,
              estateTypeSlug: "ciftlik-isyeri",
            },
            {
              id: 702,
              name: "İmalathane",
              url: "satilik-imalathane",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 66,
              estateTypeSlug: "imalathane",
            },
            {
              id: 703,
              name: "AVM",
              url: "satilik-avm",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 67,
              estateTypeSlug: "avm",
            },
            {
              id: 704,
              name: "Residence Katı & Ofisi",
              url: "satilik-residence-kati",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 68,
              estateTypeSlug: "residence-kati",
            },
            {
              id: 705,
              name: "Kıraathane",
              url: "satilik-kiraathane",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 69,
              estateTypeSlug: "kiraathane",
            },
          ],
          testSelector: "for-sale-menu-workplace-button",
        },
        {
          id: 3,
          name: "Devren İşyeri",
          url: "devren-isyeri",
          tradeTypeId: 11,
          tradeTypeSlug: "devren",
          categorySlug: "isyeri",
          child: [
            {
              id: 307,
              name: "Dükkan & Mağaza",
              url: "devren-magaza",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 41,
              estateTypeSlug: "magaza",
            },
            {
              id: 8,
              name: "Büro",
              url: "devren-buro",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 39,
              estateTypeSlug: "buro",
            },
            {
              id: 3,
              name: "Müstakil İşyeri",
              url: "devren-mustakil-isyeri",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 48,
              estateTypeSlug: "mustakil-isyeri",
            },
            {
              id: 9,
              name: "Ofis",
              url: "devren-ofis",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 49,
              estateTypeSlug: "ofis",
            },
            {
              id: 1,
              name: "Apartman Dairesi",
              url: "devren-apartman-dairesi",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 34,
              estateTypeSlug: "apartman-dairesi",
            },
            {
              id: 5,
              name: "Bina",
              url: "devren-bina-isyeri",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 36,
              estateTypeSlug: "bina-isyeri",
            },
            {
              id: 2,
              name: "Villa (İşyeri)",
              url: "devren-isyeri-villa",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 53,
              estateTypeSlug: "isyeri-villa",
            },
            {
              id: 308,
              name: "Plaza (Komple)",
              url: "devren-plaza",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 50,
              estateTypeSlug: "plaza",
            },
            {
              id: 309,
              name: "Plaza Katı",
              url: "devren-plaza-kati",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 51,
              estateTypeSlug: "plaza-kati",
            },
            {
              id: 301,
              name: "Atölye",
              url: "devren-atolye",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 35,
              estateTypeSlug: "atolye",
            },
            {
              id: 18,
              name: "Benzin İstasyonu",
              url: "devren-benzin-istasyonu",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 37,
              estateTypeSlug: "benzin-istasyonu",
            },
            {
              id: 302,
              name: "Depo",
              url: "devren-depo",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 40,
              estateTypeSlug: "depo",
            },
            {
              id: 11,
              name: "Fabrika",
              url: "devren-fabrika",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 42,
              estateTypeSlug: "fabrika",
            },
            {
              id: 304,
              name: "Hastane",
              url: "devren-hastane",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 44,
              estateTypeSlug: "hastane",
            },
            {
              id: 305,
              name: "İşhanı (Komple)",
              url: "devren-ishani",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 45,
              estateTypeSlug: "ishani",
            },
            {
              id: 306,
              name: "İşhanı Katı",
              url: "devren-ishani-kati",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 46,
              estateTypeSlug: "ishani-kati",
            },
            {
              id: 330,
              name: "Kafe & Bar",
              url: "devren-bar",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 47,
              estateTypeSlug: "bar",
            },
            {
              id: 332,
              name: "Restaurant",
              url: "devren-restaurant",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 52,
              estateTypeSlug: "restaurant",
            },
            {
              id: 303,
              name: "Genel",
              url: "devren-genel-isyeri",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 43,
              estateTypeSlug: "genel-isyeri",
            },
            {
              id: 701,
              name: "Büfe",
              url: "devren-bufe",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 38,
              estateTypeSlug: "bufe",
            },
            {
              id: 401,
              name: "Çiftlik",
              url: "devren-ciftlik-isyeri",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 62,
              estateTypeSlug: "ciftlik-isyeri",
            },
            {
              id: 702,
              name: "İmalathane",
              url: "devren-imalathane",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 66,
              estateTypeSlug: "imalathane",
            },
            {
              id: 703,
              name: "AVM",
              url: "devren-avm",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 67,
              estateTypeSlug: "avm",
            },
            {
              id: 704,
              name: "Residence Katı & Ofisi",
              url: "devren-residence-kati",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 68,
              estateTypeSlug: "residence-kati",
            },
            {
              id: 705,
              name: "Kıraathane",
              url: "devren-kiraathane",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 69,
              estateTypeSlug: "kiraathane",
            },
          ],
          testSelector: "for-sale-menu-workplace-for-transfer-button",
        },
        {
          id: 6,
          name: "Turistik Tesis",
          url: "satilik-turistik-tesis",
          tradeTypeId: 4,
          tradeTypeSlug: "satilik",
          categorySlug: "turistik-tesis",
          child: [
            {
              id: 13,
              name: "Otel",
              url: "satilik-otel",
              tradeTypeSlug: "satilik",
              categorySlug: "turistik-tesis",
              estateTypeId: 54,
              estateTypeSlug: "otel",
            },
            {
              id: 15,
              name: "Pansiyon",
              url: "satilik-pansiyon",
              tradeTypeSlug: "satilik",
              categorySlug: "turistik-tesis",
              estateTypeId: 57,
              estateTypeSlug: "pansiyon",
            },
            {
              id: 17,
              name: "Tatilköyü",
              url: "satilik-tatil-koyu",
              tradeTypeSlug: "satilik",
              categorySlug: "turistik-tesis",
              estateTypeId: 59,
              estateTypeSlug: "tatil-koyu",
            },
            {
              id: 14,
              name: "Motel",
              url: "satilik-motel",
              tradeTypeSlug: "satilik",
              categorySlug: "turistik-tesis",
              estateTypeId: 58,
              estateTypeSlug: "motel",
            },
            {
              id: 16,
              name: "Apart",
              url: "satilik-apart",
              tradeTypeSlug: "satilik",
              categorySlug: "turistik-tesis",
              estateTypeId: 56,
              estateTypeSlug: "apart",
            },
            {
              id: 12,
              name: "Butik Otel",
              url: "satilik-butik-otel",
              tradeTypeSlug: "satilik",
              categorySlug: "turistik-tesis",
              estateTypeId: 55,
              estateTypeSlug: "butik-otel",
            },
            {
              id: 610,
              name: "Kaplıca Tesisi",
              url: "satilik-kaplica-tesisi",
              tradeTypeSlug: "satilik",
              categorySlug: "turistik-tesis",
              estateTypeId: 60,
              estateTypeSlug: "kaplica-tesisi",
            },
            {
              id: 312,
              name: "Mocamp (Kamp yeri)",
              url: "satilik-kamp-yeri",
              tradeTypeSlug: "satilik",
              categorySlug: "turistik-tesis",
              estateTypeId: 61,
              estateTypeSlug: "kamp-yeri",
            },
          ],
          testSelector: "for-sale-menu-touristic-facility-button",
        },
      ],
    },
    {
      name: "Kiralık",
      url: "kiralik",
      child: [
        {
          id: 2,
          name: "Konut",
          url: "kiralik-konut",
          tradeTypeId: 6,
          tradeTypeSlug: "kiralik",
          categorySlug: "konut",
          child: [
            {
              id: 1,
              name: "Daire",
              url: "kiralik-daire",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 19,
              estateTypeSlug: "daire",
            },
            {
              id: 206,
              name: "Residence",
              url: "kiralik-residence",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 28,
              estateTypeSlug: "residence",
            },
            {
              id: 3,
              name: "Müstakil Ev",
              url: "kiralik-mustakil-ev",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 27,
              estateTypeSlug: "mustakil-ev",
            },
            {
              id: 2,
              name: "Villa",
              url: "kiralik-villa",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 30,
              estateTypeSlug: "villa",
            },
            {
              id: 6,
              name: "Yazlık",
              url: "kiralik-yazlik",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 31,
              estateTypeSlug: "yazlik",
            },
            {
              id: 10,
              name: "Devremülk",
              url: "kiralik-devremulk",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 22,
              estateTypeSlug: "devremulk",
            },
            {
              id: 201,
              name: "Çiftlik Evi",
              url: "kiralik-ciftlik-evi",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 21,
              estateTypeSlug: "ciftlik-evi",
            },
            {
              id: 202,
              name: "Dağ Evi",
              url: "kiralik-dag-evi",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 23,
              estateTypeSlug: "dag-evi",
            },
            {
              id: 205,
              name: "Köy Evi",
              url: "kiralik-koy-evi",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 26,
              estateTypeSlug: "koy-evi",
            },
            {
              id: 204,
              name: "Köşk",
              url: "kiralik-kosk",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 25,
              estateTypeSlug: "kosk",
            },
            {
              id: 4,
              name: "Yalı (Komple)",
              url: "kiralik-yali",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 32,
              estateTypeSlug: "yali",
            },
            {
              id: 207,
              name: "Yalı Dairesi",
              url: "kiralik-yali-dairesi",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 33,
              estateTypeSlug: "yali-dairesi",
            },
            {
              id: 5,
              name: "Bina",
              url: "kiralik-bina",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 20,
              estateTypeSlug: "bina",
            },
            {
              id: 203,
              name: "Kooperatif",
              url: "kiralik-kooperatif",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 24,
              estateTypeSlug: "kooperatif",
            },
            {
              id: 208,
              name: "Prefabrik",
              url: "kiralik-prefabrik",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 29,
              estateTypeSlug: "prefabrik",
            },
          ],
          testSelector: "for-rent-menu-housing-button",
        },
        {
          id: 2,
          name: "Günlük Kiralık Konut",
          url: "gunluk-kiralik-konut",
          tradeTypeId: 10,
          tradeTypeSlug: "gunluk-kiralik",
          categorySlug: "konut",
          child: [
            {
              id: 1,
              name: "Daire",
              url: "gunluk-kiralik-daire",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 19,
              estateTypeSlug: "daire",
            },
            {
              id: 206,
              name: "Residence",
              url: "gunluk-kiralik-residence",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 28,
              estateTypeSlug: "residence",
            },
            {
              id: 3,
              name: "Müstakil Ev",
              url: "gunluk-kiralik-mustakil-ev",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 27,
              estateTypeSlug: "mustakil-ev",
            },
            {
              id: 2,
              name: "Villa",
              url: "gunluk-kiralik-villa",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 30,
              estateTypeSlug: "villa",
            },
            {
              id: 6,
              name: "Yazlık",
              url: "gunluk-kiralik-yazlik",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 31,
              estateTypeSlug: "yazlik",
            },
            {
              id: 10,
              name: "Devremülk",
              url: "gunluk-kiralik-devremulk",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 22,
              estateTypeSlug: "devremulk",
            },
            {
              id: 201,
              name: "Çiftlik Evi",
              url: "gunluk-kiralik-ciftlik-evi",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 21,
              estateTypeSlug: "ciftlik-evi",
            },
            {
              id: 202,
              name: "Dağ Evi",
              url: "gunluk-kiralik-dag-evi",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 23,
              estateTypeSlug: "dag-evi",
            },
            {
              id: 205,
              name: "Köy Evi",
              url: "gunluk-kiralik-koy-evi",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 26,
              estateTypeSlug: "koy-evi",
            },
            {
              id: 204,
              name: "Köşk",
              url: "gunluk-kiralik-kosk",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 25,
              estateTypeSlug: "kosk",
            },
            {
              id: 4,
              name: "Yalı (Komple)",
              url: "gunluk-kiralik-yali",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 32,
              estateTypeSlug: "yali",
            },
            {
              id: 207,
              name: "Yalı Dairesi",
              url: "gunluk-kiralik-yali-dairesi",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 33,
              estateTypeSlug: "yali-dairesi",
            },
            {
              id: 5,
              name: "Bina",
              url: "gunluk-kiralik-bina",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 20,
              estateTypeSlug: "bina",
            },
            {
              id: 203,
              name: "Kooperatif",
              url: "gunluk-kiralik-kooperatif",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 24,
              estateTypeSlug: "kooperatif",
            },
            {
              id: 208,
              name: "Prefabrik",
              url: "gunluk-kiralik-prefabrik",
              tradeTypeSlug: "kiralik",
              categorySlug: "konut",
              estateTypeId: 29,
              estateTypeSlug: "prefabrik",
            },
          ],
          testSelector: "for-rent-menu-daily-rental-housing-button",
        },
        {
          id: 1,
          name: "Arsa",
          url: "kiralik-arsa",
          tradeTypeId: 5,
          tradeTypeSlug: "kiralik",
          categorySlug: "arsa",
          child: [
            {
              id: 1,
              name: "Konut İmarlı",
              url: "kiralik-konut-imarli-arsa",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 6,
              estateTypeSlug: "konut-imarli-arsa",
            },
            {
              id: 912,
              name: "Bağ & Bahçe",
              url: "kiralik-bag-bahce",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 1,
              estateTypeSlug: "bag-bahce",
            },
            {
              id: 12,
              name: "Tarla",
              url: "kiralik-tarla",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 13,
              estateTypeSlug: "tarla",
            },
            {
              id: 913,
              name: "Zeytinlik",
              url: "kiralik-zeytinlik",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 18,
              estateTypeSlug: "zeytinlik",
            },
            {
              id: 5,
              name: "Çiftlik",
              url: "kiralik-ciftlik",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 2,
              estateTypeSlug: "ciftlik",
            },
            {
              id: 2,
              name: "Konut/Ticaret Alanı",
              url: "kiralik-ticaret-alani",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 5,
              estateTypeSlug: "ticaret-alani",
            },
            {
              id: 3,
              name: "Toplu Konut İçin",
              url: "kiralik-toplu-konut",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 15,
              estateTypeSlug: "toplu-konut",
            },
            {
              id: 914,
              name: "Villa İmarlı",
              url: "kiralik-villa-imarli-arsa",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 17,
              estateTypeSlug: "villa-imarli-arsa",
            },
            {
              id: 7,
              name: "Ticari İmarlı",
              url: "kiralik-ticari-imarli-arsa",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 14,
              estateTypeSlug: "ticari-imarli-arsa",
            },
            {
              id: 9,
              name: "Turizm İmarlı",
              url: "kiralik-turizm-imarli-arsa",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 16,
              estateTypeSlug: "turizm-imarli-arsa",
            },
            {
              id: 8,
              name: "Sanayi İmarlı",
              url: "kiralik-sanayi-imarli-arsa",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 11,
              estateTypeSlug: "sanayi-imarli-arsa",
            },
            {
              id: 11,
              name: "Depo/Antrepo İzinli",
              url: "kiralik-depo-antrepo-izinli",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 3,
              estateTypeSlug: "depo-antrepo-izinli",
            },
            {
              id: 13,
              name: "Hastane (Sağlık Tesisi)",
              url: "kiralik-arsa-hastane",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 4,
              estateTypeSlug: "arsa-hastane",
            },
            {
              id: 14,
              name: "Okul (Eğitim Tesisi)",
              url: "kiralik-okul-arsasi",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 9,
              estateTypeSlug: "okul-arsasi",
            },
            {
              id: 10,
              name: "Maden Ocağı",
              url: "kiralik-maden-ocagi",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 7,
              estateTypeSlug: "maden-ocagi",
            },
            {
              id: 6,
              name: "Muhtelif Arsa",
              url: "kiralik-muhtelif-arsa",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 8,
              estateTypeSlug: "muhtelif-arsa",
            },
            {
              id: 4,
              name: "Özel Kullanım",
              url: "kiralik-ozel-arsa",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 10,
              estateTypeSlug: "ozel-arsa",
            },
            {
              id: 15,
              name: "Sit Alanı",
              url: "kiralik-sit-alani",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 12,
              estateTypeSlug: "sit-alani",
            },
            {
              id: 915,
              name: "Turizm/Konut Alanı",
              url: "kiralik-turizm-konut-alani",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 63,
              estateTypeSlug: "turizm-konut-alani",
            },
            {
              id: 916,
              name: "Ada",
              url: "kiralik-ada",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 64,
              estateTypeSlug: "ada",
            },
            {
              id: 917,
              name: "Arazi",
              url: "kiralik-arazi",
              tradeTypeSlug: "kiralik",
              categorySlug: "arsa",
              estateTypeId: 65,
              estateTypeSlug: "arazi",
            },
          ],
          testSelector: "for-rent-menu-land-button",
        },
        {
          id: 3,
          name: "İşyeri",
          url: "kiralik-isyeri",
          tradeTypeId: 7,
          tradeTypeSlug: "kiralik",
          categorySlug: "isyeri",
          child: [
            {
              id: 307,
              name: "Dükkan & Mağaza",
              url: "kiralik-magaza",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 41,
              estateTypeSlug: "magaza",
            },
            {
              id: 8,
              name: "Büro",
              url: "kiralik-buro",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 39,
              estateTypeSlug: "buro",
            },
            {
              id: 3,
              name: "Müstakil İşyeri",
              url: "kiralik-mustakil-isyeri",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 48,
              estateTypeSlug: "mustakil-isyeri",
            },
            {
              id: 9,
              name: "Ofis",
              url: "kiralik-ofis",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 49,
              estateTypeSlug: "ofis",
            },
            {
              id: 1,
              name: "Apartman Dairesi",
              url: "kiralik-apartman-dairesi",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 34,
              estateTypeSlug: "apartman-dairesi",
            },
            {
              id: 5,
              name: "Bina",
              url: "kiralik-bina-isyeri",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 36,
              estateTypeSlug: "bina-isyeri",
            },
            {
              id: 2,
              name: "Villa (İşyeri)",
              url: "kiralik-isyeri-villa",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 53,
              estateTypeSlug: "isyeri-villa",
            },
            {
              id: 308,
              name: "Plaza (Komple)",
              url: "kiralik-plaza",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 50,
              estateTypeSlug: "plaza",
            },
            {
              id: 309,
              name: "Plaza Katı",
              url: "kiralik-plaza-kati",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 51,
              estateTypeSlug: "plaza-kati",
            },
            {
              id: 301,
              name: "Atölye",
              url: "kiralik-atolye",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 35,
              estateTypeSlug: "atolye",
            },
            {
              id: 18,
              name: "Benzin İstasyonu",
              url: "kiralik-benzin-istasyonu",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 37,
              estateTypeSlug: "benzin-istasyonu",
            },
            {
              id: 302,
              name: "Depo",
              url: "kiralik-depo",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 40,
              estateTypeSlug: "depo",
            },
            {
              id: 11,
              name: "Fabrika",
              url: "kiralik-fabrika",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 42,
              estateTypeSlug: "fabrika",
            },
            {
              id: 304,
              name: "Hastane",
              url: "kiralik-hastane",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 44,
              estateTypeSlug: "hastane",
            },
            {
              id: 305,
              name: "İşhanı (Komple)",
              url: "kiralik-ishani",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 45,
              estateTypeSlug: "ishani",
            },
            {
              id: 306,
              name: "İşhanı Katı",
              url: "kiralik-ishani-kati",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 46,
              estateTypeSlug: "ishani-kati",
            },
            {
              id: 330,
              name: "Kafe & Bar",
              url: "kiralik-bar",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 47,
              estateTypeSlug: "bar",
            },
            {
              id: 332,
              name: "Restaurant",
              url: "kiralik-restaurant",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 52,
              estateTypeSlug: "restaurant",
            },
            {
              id: 303,
              name: "Genel",
              url: "kiralik-genel-isyeri",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 43,
              estateTypeSlug: "genel-isyeri",
            },
            {
              id: 701,
              name: "Büfe",
              url: "kiralik-bufe",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 38,
              estateTypeSlug: "bufe",
            },
            {
              id: 401,
              name: "Çiftlik",
              url: "kiralik-ciftlik-isyeri",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 62,
              estateTypeSlug: "ciftlik-isyeri",
            },
            {
              id: 702,
              name: "İmalathane",
              url: "kiralik-imalathane",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 66,
              estateTypeSlug: "imalathane",
            },
            {
              id: 703,
              name: "AVM",
              url: "kiralik-avm",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 67,
              estateTypeSlug: "avm",
            },
            {
              id: 704,
              name: "Residence Katı & Ofisi",
              url: "kiralik-residence-kati",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 68,
              estateTypeSlug: "residence-kati",
            },
            {
              id: 705,
              name: "Kıraathane",
              url: "kiralik-kiraathane",
              tradeTypeSlug: "kiralik",
              categorySlug: "isyeri",
              estateTypeId: 69,
              estateTypeSlug: "kiraathane",
            },
          ],
          testSelector: "for-rent-menu-workplace-button",
        },
        {
          id: 6,
          name: "Turistik Tesis",
          url: "kiralik-turistik-tesis",
          tradeTypeId: 8,
          tradeTypeSlug: "kiralik",
          categorySlug: "turistik-tesis",
          child: [
            {
              id: 13,
              name: "Otel",
              url: "kiralik-otel",
              tradeTypeSlug: "kiralik",
              categorySlug: "turistik-tesis",
              estateTypeId: 54,
              estateTypeSlug: "otel",
            },
            {
              id: 15,
              name: "Pansiyon",
              url: "kiralik-pansiyon",
              tradeTypeSlug: "kiralik",
              categorySlug: "turistik-tesis",
              estateTypeId: 57,
              estateTypeSlug: "pansiyon",
            },
            {
              id: 17,
              name: "Tatilköyü",
              url: "kiralik-tatil-koyu",
              tradeTypeSlug: "kiralik",
              categorySlug: "turistik-tesis",
              estateTypeId: 59,
              estateTypeSlug: "tatil-koyu",
            },
            {
              id: 14,
              name: "Motel",
              url: "kiralik-motel",
              tradeTypeSlug: "kiralik",
              categorySlug: "turistik-tesis",
              estateTypeId: 58,
              estateTypeSlug: "motel",
            },
            {
              id: 16,
              name: "Apart",
              url: "kiralik-apart",
              tradeTypeSlug: "kiralik",
              categorySlug: "turistik-tesis",
              estateTypeId: 56,
              estateTypeSlug: "apart",
            },
            {
              id: 12,
              name: "Butik Otel",
              url: "kiralik-butik-otel",
              tradeTypeSlug: "kiralik",
              categorySlug: "turistik-tesis",
              estateTypeId: 55,
              estateTypeSlug: "butik-otel",
            },
            {
              id: 610,
              name: "Kaplıca Tesisi",
              url: "kiralik-kaplica-tesisi",
              tradeTypeSlug: "kiralik",
              categorySlug: "turistik-tesis",
              estateTypeId: 60,
              estateTypeSlug: "kaplica-tesisi",
            },
            {
              id: 312,
              name: "Mocamp (Kamp yeri)",
              url: "kiralik-kamp-yeri",
              tradeTypeSlug: "kiralik",
              categorySlug: "turistik-tesis",
              estateTypeId: 61,
              estateTypeSlug: "kamp-yeri",
            },
          ],
          testSelector: "for-rent-menu-touristic-facility-button",
        },
      ],
    },
    {
      name: "Projeler",
      url: "satilik-konut/projeler",
      child: [
        {
          id: 2,
          name: "Konut",
          url: "satilik-konut/projeler",
          tradeTypeId: 2,
          tradeTypeSlug: "satilik",
          categorySlug: "konut",
          child: [
            {
              id: 1,
              name: "Daire",
              url: "satilik-daire/projeler",
              tradeTypeSlug: "satilik",
              categorySlug: "konut",
              estateTypeId: 19,
              estateTypeSlug: "daire",
            },
            {
              id: 206,
              name: "Residence",
              url: "satilik-residence/projeler",
              tradeTypeSlug: "satilik",
              categorySlug: "konut",
              estateTypeId: 28,
              estateTypeSlug: "residence",
            },
            {
              id: 2,
              name: "Villa",
              url: "satilik-villa/projeler",
              tradeTypeSlug: "satilik",
              categorySlug: "konut",
              estateTypeId: 30,
              estateTypeSlug: "villa",
            },
          ],
          testSelector: "projects-menu-housing-button",
        },
        {
          id: 1,
          name: "Arsa",
          url: "satilik-arsa/projeler",
          tradeTypeId: 1,
          tradeTypeSlug: "satilik",
          categorySlug: "arsa",
          child: [
            {
              id: 1,
              name: "Konut İmarlı",
              url: "satilik-konut-imarli-arsa/projeler",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 6,
              estateTypeSlug: "konut-imarli-arsa",
            },
            {
              id: 912,
              name: "Bağ & Bahçe",
              url: "satilik-bag-bahce/projeler",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 1,
              estateTypeSlug: "bag-bahce",
            },
            {
              id: 12,
              name: "Tarla",
              url: "satilik-tarla/projeler",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 13,
              estateTypeSlug: "tarla",
            },
            {
              id: 914,
              name: "Villa İmarlı",
              url: "satilik-villa-imarli-arsa/projeler",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 17,
              estateTypeSlug: "villa-imarli-arsa",
            },
            {
              id: 7,
              name: "Ticari İmarlı",
              url: "satilik-ticari-imarli-arsa/projeler",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 14,
              estateTypeSlug: "ticari-imarli-arsa",
            },
            {
              id: 9,
              name: "Turizm İmarlı",
              url: "satilik-turizm-imarli-arsa/projeler",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 16,
              estateTypeSlug: "turizm-imarli-arsa",
            },
            {
              id: 4,
              name: "Özel Kullanım",
              url: "satilik-ozel-arsa/projeler",
              tradeTypeSlug: "satilik",
              categorySlug: "arsa",
              estateTypeId: 10,
              estateTypeSlug: "ozel-arsa",
            },
          ],
          testSelector: "projects-menu-land-button",
        },
        {
          id: 3,
          name: "İşyeri",
          url: "satilik-isyeri/projeler",
          tradeTypeId: 3,
          tradeTypeSlug: "satilik",
          categorySlug: "isyeri",
          child: [
            {
              id: 307,
              name: "Dükkan & Mağaza",
              url: "satilik-magaza/projeler",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 41,
              estateTypeSlug: "magaza",
            },
            {
              id: 9,
              name: "Ofis",
              url: "satilik-ofis/projeler",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 49,
              estateTypeSlug: "ofis",
            },
            {
              id: 302,
              name: "Depo",
              url: "satilik-depo/projeler",
              tradeTypeSlug: "satilik",
              categorySlug: "isyeri",
              estateTypeId: 40,
              estateTypeSlug: "depo",
            },
          ],
          testSelector: "projects-menu-workplace-button",
        },
      ],
    },
    {
      name: "Emlak Ofisleri",
      url: "emlak-ofisleri",
    },
  ],
};
